import type { IconData } from '@stacksjs/iconify-core'

export const viewColumn: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M16 64v384h480V64Zm304 32v320H192V96ZM48 96h112v320H48Zm416 320H352V96h112Z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default viewColumn
